import { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const CheckmarkCircle: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="19.9999"
      cy="19.9999"
      r="15.0062"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0708 20.5653L17.684 24.1785L17.6606 24.1551L25.8124 16.0034"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
